import { useEffect } from 'react';
import type { UserMessage } from 'autogen/swagger/all';
import toast from 'components/Toast';

export type UserMessageToastProps = {
    type: UserMessage['messageType'];
    message: string;
};

export const spawnAlertToast = (message: string, type: UserMessage['messageType']) => {
    switch (type) {
        case 'Alert_Success':
            toast.success<string>(message, {
                position: 'top-right'
            });
            break;
        case 'Alert_Danger':
            toast.error<string>(message, {
                position: 'top-right'
            });
            break;
        default:
            break;
    }
};

export default function UserMessageToast(props: UserMessageToastProps) {
    const { type, message } = props;

    useEffect(() => {
        spawnAlertToast(message, type);
    }, []);

    return null;
}
